import type { UUID } from "../../../utils/uuid";

export type Claims = {
  org_id: string;
  org_name: string;
  sub: string;
  role: string;
  "http://changeengine.com/supabase_url": string;
  "http://changeengine.com/supabase_anon_key": string;
  "http://changeengine.com/account_id": UUID;
  "http://changeengine.com/person_id": UUID;
  "http://changeengine.com/ce_admin": boolean;
  "http://changeengine.com/super_admin": boolean;
  "http://changeengine.com/editable_program": UUID[] | null;
  "http://changeengine.com/read_only_program": UUID[] | null;
};

export const getClaims = (token: string): Claims =>
  JSON.parse(atob(token.split(".")[1]!)) as Claims;
